var _path, _g, _path2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_228_4605",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2H17.3784V17.0389H2V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_228_4605)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.68947 3.15816C6.10242 3.15816 3.18414 6.01121 3.18414 9.51903C3.18414 13.0268 6.10242 15.8807 9.68947 15.8807C13.2757 15.8807 16.194 13.0268 16.194 9.51903C16.194 6.01121 13.2757 3.15816 9.68947 3.15816ZM9.68951 17.0389C5.44948 17.0389 1.99982 13.6655 1.99982 9.51907C1.99982 5.3727 5.44948 2 9.68951 2C13.9295 2 17.3784 5.3727 17.3784 9.51907C17.3784 13.6655 13.9295 17.0389 9.68951 17.0389Z",
    fill: "#A0ACB9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_228_4605",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 14,
    width: 4,
    height: 4
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0331 14.1279H18V18H14.0331V14.1279Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_228_4605)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4079 18C17.2571 18 17.1055 17.9437 16.9895 17.8309L14.207 15.1176C13.9756 14.8914 13.9749 14.5246 14.2062 14.2984C14.4368 14.0706 14.8118 14.0722 15.0439 14.2968L17.8264 17.0109C18.0578 17.2371 18.0585 17.6031 17.8272 17.8294C17.7119 17.9437 17.5595 18 17.4079 18Z",
    fill: "#A0ACB9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightSearch);
export default __webpack_public_path__ + "static/media/lightSearch.555ff9e2a7969a15042c7598969b69ec.svg";
export { ForwardRef as ReactComponent };